import './showroomcarousel.scss';
import {encodeUriParts} from '../../Shared/Assets/encodeUriParts';
import {CarouselUtils} from '../../Shared/Assets/carousel-utils';

import Swiper from 'swiper';
import { Navigation, Pagination, FreeMode } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
Swiper.use([Navigation, Pagination,FreeMode]);

class ShowroomCarousel {
	init() {
		const sectionEl = document.querySelector('[data-role="showroom-carousel-section"]');
		this.buildShowroom(sectionEl);
	}

	buildPostcodeSelector(sectionEl) {
		this.readArea = document.querySelector('[data-role="postcode-selector-read"]');
		this.editArea = document.querySelector('[data-role="postcode-selector-edit"]');
		this.btnCancel = document.querySelector('[data-role="postcode-selector-edit-cancel"]');
		this.btnSave = document.querySelector('[data-role="postcode-selector-edit-save"]');
		this.postCode = document.querySelector('[data-role="txt-postcode-selector"]');
		this.loading = document.querySelector('[data-role="postcode-selector-loading"]');

		this.readArea.querySelector('a').addEventListener('click', (evt) => {
			this.postcodeToggle(evt);
		});

		this.btnCancel.addEventListener('click', (evt) => {
			this.postcodeToggle(evt);
		});

		this.btnSave.addEventListener('click', (evt) => {
			this.savePostcode(evt, sectionEl);
		});
	}

	postcodeToggle(evt) {
		this.readArea.classList.toggle('d-none');
		this.editArea.classList.toggle('d-none');
		evt.preventDefault();
	}

	savePostcode(evt, sectionEl) {
		if (!this.editArea.checkValidity())
			return;

		this.btnSave.classList.toggle('d-none');
		this.btnCancel.classList.toggle('d-none');
		this.loading.classList.toggle('d-none');

		let url = this.editArea.getAttribute('data-url');
		let model = {
			postcode: this.postCode.value
		};
		$.ajax({
			type: "POST",
			url: url,
			async: false,
			contentType: 'application/json',
			data: JSON.stringify(model),
			success: (results) => {
				this.filterCars(sectionEl, this.currentFilter);
				this.postcodeToggle(evt);
			},
			error: (ef) => {
				alert('An error occurred');
				console.log(ef);
			}
		});
		evt.preventDefault();
	}
	
	buildShowroom(sectionEl) {
		if (CarouselUtils.isMobile()) {
			sectionEl.classList.add('has-touch');
		} else {
			sectionEl.classList.remove('has-touch');
		}
		
		this.buildPostcodeSelector(sectionEl);
		this.buildSortCarousel(sectionEl);
		this.buildCarsCarousel(sectionEl);
	}
	buildSortCarousel(sectionEl) {
		const els = sectionEl.querySelectorAll('[data-role="hpl-sort"]');
		els.forEach((el,i) => {
			if (i === 0) {
				this.currentFilter = el.getAttribute('data-filter-id'); //get the default filterId
			}
			el.addEventListener("click", e => {
				this.handleShowroomSortClick(e,el,sectionEl);
			});
		});

		const swiperSortSectionEl = sectionEl.querySelector('[data-role="swiper-sort-section"]');
		const sortConfigs = this.getShowroomSortConfigs(sectionEl,swiperSortSectionEl);
		const swiperSortEl = swiperSortSectionEl.querySelector('[data-role="swiper"]');
		new Swiper(swiperSortEl,sortConfigs);
	}
	buildCarsCarousel(sectionEl) {
		const swiperSectionEl = sectionEl.querySelector('[data-role="swiper-section"]');
		const configs = this.getShowroomConfigs(sectionEl,swiperSectionEl);
		const swiperEl = swiperSectionEl.querySelector('[data-role="swiper"]');
		new Swiper(swiperEl,configs);
	}
	getShowroomConfigs(sectionEl,swiperSectionEl) {
		if (CarouselUtils.isMobile()) {
			const slidesOffset = CarouselUtils.getSlidesOffset(sectionEl);
			const spaceBetween = 8;
			const slides = 2;
			return {
				//https://swiperjs.com/swiper-api
				edgeSwipeDetection: true,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				roundLengths: true,

				//responsive
				slidesPerView: slides,
				spaceBetween,
				slidesOffsetBefore: slidesOffset,
				slidesOffsetAfter: slidesOffset
			}
		}

		//desktop
		const pagination = CarouselUtils.usePagination(swiperSectionEl);
		const navigation = CarouselUtils.useNavs(swiperSectionEl, CarouselUtils.isLargeScreen());
		return {
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			roundLengths: true,
			speed:500,

			slidesPerView: 2,
			spaceBetween: 16,
			pagination,
			navigation,
			breakpoints: {
				768: {
					slidesPerView: 3,
					slidesPerGroup: 3
				},
				992: {
					slidesPerView: 4,
					slidesPerGroup: 4
				},
				1200: {
					slidesPerView: 6,
					slidesPerGroup: 6
				},
			},
		};
	}
	getShowroomSortConfigs(sectionEl) {
		let config = {
			spaceBetween: 8,
			slidesPerView: 'auto',
			freeMode: {
				enabled: true,
				momentumRatio: 0.85,
				momentumVelocityRatio: 0.75
			}
		};

		if (CarouselUtils.isMobile()) {
			const slidesOffset = CarouselUtils.getSlidesOffset(sectionEl);
			config = Object.assign(config,{
				slidesOffsetBefore: slidesOffset,
				slidesOffsetAfter: slidesOffset
			})
		}
		
		return config;
	}
	handleShowroomSortClick(e, el, sectionEl) {
		e.preventDefault();
		this.currentFilter = el.getAttribute('data-filter-id');
		this.setActiveFilter(sectionEl, this.currentFilter);
		this.filterCars(sectionEl, this.currentFilter);
	}
	async filterCars(sectionEl, filterId) {
		const hubSlug = sectionEl.getAttribute('data-hub-slug')?.trim();
		if (!hubSlug) { return; }
		
		this.setLoading(sectionEl, true);
		const params = {
			filterId
		};
		const newUrl = `${document.location.protocol}//${location.host}/_showroomContentHub/api/v1/refresh/${hubSlug}/?${encodeUriParts(params)}`;
		const response = await this.fetchCars(newUrl);
		if (response.ok) {
			const { showroomCarousel : htmlStr } = await response.json();
			this.refresh(sectionEl, htmlStr);
		}
		this.setLoading(sectionEl, false);
	}
	async fetchCars(url) {
		return window.fetch(url, {
			method: 'GET',
			credentials: 'same-origin',
			headers: {
				RequestVerificationToken: document.querySelector('input[type="hidden"][name="__RequestVerificationToken"]').value
			}
		});
	}
	refresh(sectionEl, htmlStr) {
		if (htmlStr) {
			//set html, re init carousel
			const temp = document.createElement('template');
			temp.innerHTML = htmlStr;
			const newSectionEl = temp.content.querySelector('[data-role="showroom-carousel-section"]');
			
			const newCarsSwiperSectionEl = newSectionEl.querySelector('[data-role="swiper-section"]');
			const currentCarsSwiperSectionEl = sectionEl.querySelector('[data-role="swiper-section"]');
			currentCarsSwiperSectionEl.replaceWith(newCarsSwiperSectionEl);

			const newPostcodeSelector = newSectionEl.querySelector('[data-role="postcode-selector"]');
			const currentPostcodeSelector = sectionEl.querySelector('[data-role="postcode-selector"]');
			currentPostcodeSelector.replaceWith(newPostcodeSelector);
			
			this.buildPostcodeSelector(sectionEl);
			this.buildCarsCarousel(sectionEl);
		}
	}
	setLoading(el,enable) {
		if (el) {
			el.classList.toggle('is-loading',enable);
		}
	}
	setActiveFilter(sectionEl, filterId) {
		const els = sectionEl.querySelectorAll('[data-role="hpl-sort"]');
		const result = Array.from(els).map(el => {
			const id = el.getAttribute('data-filter-id');
			(id === filterId ? el.classList.toggle('active', true) : el.classList.toggle('active', false));
		});
	}
}

window.addEventListener("load", () => new ShowroomCarousel().init());